import { useEffect, useState } from 'react';
import type { UndoManager } from '@annoteer/sync-layer';

/**
 * Hook that subscribes to UndoManager state changes for reactive UI updates.
 */
export function useUndoState(undoManager: UndoManager | null) {
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  useEffect(() => {
    if (!undoManager) return;
    const unsubscribe = undoManager.onStateChange((undo, redo) => {
      setCanUndo(undo);
      setCanRedo(redo);
    });
    return unsubscribe;
  }, [undoManager]);

  return { canUndo, canRedo };
}
